import CardContainer from '@/components/cards/CardContainer';
import Container, {
	Column,
	Column as FlexColumn,
} from '@/components/container/Container';
import SimpleTable from '@/components/table/SimpleTable';
import { CustomText, TextLabelLarge } from '@/components/text/Texts';
import LoadingProgressBar from '@/components/utils/LoadingProgressBar';
import { ACTIVE_USERS_LAST } from '@/constants/insights-page';
import _ from 'lodash';
import CardContentSkeleton from './CardContentSkeleton';
import EmptyScreen from './EmptyScreen';

type Props = {
	hasError: boolean | null;
	hasData: boolean | null;
	isLoaded: boolean;
	data: {
		product: string;
		activeUsers: number;
	}[];
	title: string;
};

const ActiveUsersSection = ({
	hasData,
	hasError,
	isLoaded,
	data,
	title,
}: Props) => {
	//const activeUsersCount = 430;

	const columns = [
		{ field: 'product', header: 'Product' },
		{ field: 'activeUsers', header: 'Active Users' },
	];

	const stateTemplate = () => {
		if (hasData === null || hasError == null)
			return (
				<Column gap="gap-4">
					<Container className="-mt-6">
						<LoadingProgressBar />
					</Container>
					<CardContentSkeleton />
				</Column>
			);

		if (!hasData) {
			return <EmptyScreen isError={hasData} height="h-[470px]" />;
		}

		if (hasError) {
			return (
				<EmptyScreen
					isError={hasData}
					// hasError={hasError}
					height="h-[470px]"
				/>
			);
		}
	};

	return (
		<CardContainer>
			<Container className="p-6 bg-white rounded-[24px] h-auto">
				{!isLoaded ? (
					stateTemplate()
				) : (
					<FlexColumn gap="gap-4">
						<FlexColumn gap="gap-2">
							<TextLabelLarge
								className="text-black"
								text={`${ACTIVE_USERS_LAST} ${_.lowerFirst(title)}`}
							/>
							<CustomText
								className="text-primary font-medium text-[44px] leading-[52px]"
								// [0] is fine for now, since we have no programs in fact
								text={data[0].activeUsers.toString()}
							/>
						</FlexColumn>
						{/* TODO[Phase2]: this is currently one row table because we have no programs */}
						<SimpleTable data={data} columns={columns} />
					</FlexColumn>
				)}
			</Container>
		</CardContainer>
	);
};

export default ActiveUsersSection;
